import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { GET_COHORTS_QUERY_KEY } from './useGetCohorts';

export function useDeleteCohort(organizationId: string) {
  const queryClient = useQueryClient();
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: async (cohortId: string) => {
      const response = await apiClient.fetchApi<{}, { success: boolean }>({
        method: 'DELETE',
        endpoint: `cohorts/${cohortId}`,
      });
      return response;
    },
    onSuccess: () => {
      // Invalidate cohorts list
      queryClient.invalidateQueries({
        queryKey: GET_COHORTS_QUERY_KEY(organizationId),
      });
    },
  });
}
